import * as yup from "yup";

export const populateForm = (value) => {
  return {
    id: value.id,
    keycloackId: value.keycloackId,
    firstName: value.firstName,
    lastName: value.lastName,
    username: value.username,
    email: value.email,
    mobile: value.mobile,
    designation: value.designation,
    mobileExt: value.mobileExt,
    country: value.country,
    location: value.location,
    password: value.password,
    confirmPassword: value.confirmPassword,
    employeeId: value.employeeId,
    managerId: value.managerId,
    status: value.status,
    passwordCheck: value.passwordCheck,
    department: value.department,
    officeExt: value.officeExt,
    officeNo: value.officeNo,
  };
};

export const initialValues = {
  firstName: "",
  lastName: "",
  username: "",
  email: "",
  mobile: "",
  designation: "",
  mobileExt: "",
  location: "",
  country: "",
  password: "",
  confirmPassword: "",
  employeeId: "",
  managerId: null,
  status: null,
  groups: [],
  passwordCheck: false,
  department: "",
  officeExt: "",
  officeNo: "",
};

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

export const schema = yup.object().shape({
  id: yup.number().nullable().notRequired(),
  keycloackId: yup.string().nullable().notRequired(),
  firstName: yup.string().required("Please enter a first name."),
  lastName: yup.string().required("Please enter a last name."),
  username: yup.string().required("Please enter a username."),
  email: yup.string().required("Please enter an email address."),
  mobile: yup
    .string()
    .required("Please enter a mobile number.")
    .min(10, "Mobile number must be at least 10 digits long."),
  designation: yup.string().required("Please enter a designation."),
  mobileExt: yup.string().required("Please select a mobile ext."),
  location: yup.string().required("Please select a location."),
  country: yup.string().required("Please select a country."),
  password: yup
    .string()
    .required("Please enter a password.")
    .min(8, "Password must be at least 8 characters long.")
    .matches(
      passwordRegex,
      "Password must be at least 8 characters long, with at least one uppercase letter, one lowercase letter, one digit, and one special character."
    ),
  confirmPassword: yup
    .string()
    .required("Please confirm your password.")
    .oneOf([yup.ref("password")], "Passwords must match."),
  employeeId: yup.string().required("Please enter the Employee ID."),
  // Id is a number
  managerId: yup.number().required("Please select a manager."),
  status: yup.bool().required("Please select an status."),
  groups: yup.array().nullable().notRequired(),
  department: yup.string().required("Please enter a department."),
  officeExt: yup.string().required("Please select an office ext."),
  officeNo: yup.string().required("Please enter an office number."),
});

export const updateSchema = yup.object().shape({
  id: yup.number().nullable().notRequired(),
  keycloackId: yup.string().nullable().notRequired(),
  firstName: yup.string().required("Please enter a first name."),
  lastName: yup.string().required("Please enter a last name."),
  username: yup.string().required("Please enter a username."),
  email: yup.string().required("Please enter an email address."),
  mobile: yup
    .string()
    .required("Please enter a mobile number.")
    .min(10, "Mobile number must be at least 10 digits long."),
  designation: yup.string().required("Please enter a designation."),
  mobileExt: yup.string().required("Please select a mobile ext."),
  location: yup.string().required("Please select a location."),
  country: yup.string().required("Please select a country."),
  password: yup.string().when("passwordCheck", {
    is: true,
    then: (s) =>
      s
        .required("Please enter a password.")
        .min(8, "Password must be at least 8 characters long.")
        .matches(
          passwordRegex,
          "Password must be at least 8 characters long, with at least one uppercase letter, one lowercase letter, one digit, and one special character."
        ),
  }),
  confirmPassword: yup.string().when("passwordCheck", {
    is: true,
    then: (s) =>
      s
        .required("Please confirm your password.")
        .oneOf([yup.ref("password")], "Passwords must match."),
  }),
  employeeId: yup.string().required("Please enter the Employee ID."),
  // Id is a number
  managerId: yup.number().required("Please select a manager."),
  status: yup.bool().required("Please select an status."),
  department: yup.string().required("Please enter a department."),
  officeExt: yup.string().required("Please select an office ext."),
  officeNo: yup.string().required("Please enter an office number."),
});
